module.exports = "/cyber/_next/static/images/MobileWidgetPS-9962cd0f403fb8b33444017ce177a944.png";